export const palette = {
  light: {
    bg: {
      default: '#FAFAF9',
      surface: '#FFFFFF',
      subtle: '#F4F4F3',
      userBubble: '#ECFDF5',
    },
    border: {
      subtle: '#EAEAE8',
      default: '#D4D4D2',
    },
    text: {
      primary: '#1F2024',
      secondary: '#5A5C63',
      tertiary: '#8A8C92',
    },
    accent: {
      primary: '#10B981',
      hover: '#059669',
      subtle: '#ECFDF5',
    },
    semantic: {
      success: '#15803D',
      warning: '#B45309',
      error: '#B91C1C',
    },
  },
  dark: {
    bg: {
      default: '#0F1014',
      surface: '#17181D',
      subtle: '#1E2026',
      userBubble: '#0F2920',
    },
    border: {
      subtle: '#26282F',
      default: '#32343C',
    },
    text: {
      primary: '#E8E8EA',
      secondary: '#A0A2A8',
      tertiary: '#6D6F76',
    },
    accent: {
      primary: '#34D399',
      hover: '#6EE7B7',
      subtle: '#0F2920',
    },
    semantic: {
      success: '#22C55E',
      warning: '#F59E0B',
      error: '#EF4444',
    },
  },
} as const;

export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 24,
  6: 32,
  7: 48,
} as const;

export const radius = {
  sm: 6,
  md: 10,
  lg: 14,
  xl: 18,
} as const;

export const shadow = {
  light: {
    1: '0 1px 2px rgba(15,16,20,0.04), 0 1px 1px rgba(15,16,20,0.03)',
    2: '0 4px 12px rgba(15,16,20,0.06)',
    focus: '0 0 0 3px rgba(16,185,129,0.18)',
  },
  dark: {
    1: 'none',
    2: '0 4px 12px rgba(0,0,0,0.4)',
    focus: '0 0 0 3px rgba(52,211,153,0.28)',
  },
} as const;

export const typography = {
  fontFamilySans: "'IBM Plex Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
  fontFamilyMono: "'IBM Plex Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
  sizes: {
    display: 28,
    h1: 18,
    h2: 13,
    body: 15,
    bodySmall: 13,
    caption: 12,
    mono: 13.5,
  },
  lineHeights: {
    display: 1.25,
    h1: 1.35,
    h2: 1.4,
    body: 1.6,
    bodySmall: 1.5,
    caption: 1.45,
    mono: 1.55,
  },
} as const;

export const transition = {
  fast: '120ms ease-out',
  base: '180ms ease-out',
  slow: '220ms cubic-bezier(0.4, 0, 0.2, 1)',
} as const;

export type ThemeMode = 'light' | 'dark';
